import React, { Component, Fragment } from 'react'
import ReactPlayer from 'react-player'

import Registry from '../../../registry/index'

class ChatLogItemWallPost extends Component {
    state = {
        showBanner: false,
        videoPopup: false,
        incremented: false,
        continuouslyPlayed: 0,
    };
    
    switchVideoPopup = e => {
        if (e.target.tagName === "VIDEO") return;
        const {videoPopup} = this.state;
        if (!videoPopup) {
           document.getElementsByClassName('scrollbars')[0].children[0].style.overflow = '';
        } else {
            document.getElementsByClassName('scrollbars')[0].children[0].style.overflow = 'scroll';
        }
        this.setState({videoPopup: !videoPopup, showBanner: false});
    };
    
    onStart = () => {
        const {message: {material_id}} = this.props;
        const siteInterface = Registry.get("siteInterface");
        siteInterface.incrementWallItemViews({id: material_id})
    }

    onEnded = () => {
        const {currentUser} = this.props;
        const isXXL = currentUser.isXXL();
        
        if (!isXXL) {
            this.setState({showBanner: true});
        }
    }
    
    render() {
        const {message} = this.props;
        const {videoPopup, showBanner} = this.state;
        
        if (!message.sender) return null;
    
        const lang = Registry.get('locale');
        
        const prefix = document.location.pathname.includes('/en/') ? '/en/' : '/';
        const becomeXXLLink = document.location.origin +  prefix + 'bobtv-xxl';

        const senderBlock = <a href={lang.path + message.senderProfileURL} target="_blank" className="sender">{message.sender}</a>;
        return (
            <div className="wall-post-notification">
                <div className="thumbnail">
                    {message.type === "video" ?
                        <Fragment>
                            <span onClick={this.switchVideoPopup}>
                                <img src={message.thumbnail_url} alt=""/>
                            </span>
                            {videoPopup &&
                                <div className="video-overlay" onClick={this.switchVideoPopup}>
                                    <div className="inner-container">
                                        <ReactPlayer
                                          playing
                                          controls
                                          url={message.media_url}
                                          className="video-popup"
                                          volume={0.7}
                                          config={{
                                              file: {
                                                  attributes: {
                                                      controlsList: 'nodownload',
                                                      disablepictureinpicture: 'true'
                                                  }
                                              }
                                          }}
                                          onContextMenu={e => e.preventDefault()}
                                          onStart={this.onStart}
                                          onEnded={this.onEnded}
                                        />
                                        {showBanner &&
                                            <div className="banner">
                                                <div className="text">{lang.XXLBannerText}</div>
                                                <a href={becomeXXLLink} target="_blank" className="become-xxl">{lang.XXLBannerButton}</a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </Fragment>
                        : <a href={message.media_url} className="fancybox" title={message.title}><img src={message.thumbnail_url} alt=""/></a>
                    }
                </div>
                <div className="text">
                    {senderBlock} {lang.sent_new_wall_post} <a href={message.url} target="_blank" className="post-page">{lang.the_wall}</a>
                </div>
            </div>
        )
    }
}

export default ChatLogItemWallPost;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemWallPost/index.js